import React, { useEffect, createElement } from 'react';
import { SiteFooter } from '../components/ui/SiteFooter';
export function PractitionersPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-502" data-mp="3w2sr2s1yrdhq">
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-503" data-mp="3s1pa2286jbex">
        <a href="/" data-id="element-504" data-mp="3n3nuhr9ypu87">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-505" data-mp="3i39jc0d2e45y" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-506" data-mp="26nbfqc0noac4">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-507" data-mp="zkug0293s9nl">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-508" data-mp="13n8xoj11d3da">
            Get the App
          </a>
          <a href="/practitioners" className="text-purple-700 font-semibold" data-id="element-509" data-mp="ppkcfa323u7p">
            Practitioners
          </a>
        </div>
      </nav>

      <section className="pt-40 pb-24 px-6" data-id="element-510" data-mp="fx4sw8c42xkp">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-511" data-mp="fva8cv4r57h5">
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-purple-700 mb-5" data-id="element-512" data-mp="kp4z2iirympq">
            For Practitioners
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal leading-[1.1] mb-6 tracking-tight" data-id="element-513" data-mp="bvt1pydla4ae">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-514" data-mp="3t57v1r0iymy8">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness. Complete the form below to apply.
          </p>
        </div>

        <div className="max-w-3xl mx-auto rounded-3xl border border-purple-100 bg-white/80 backdrop-blur-md shadow-xl p-2 md:p-4" data-id="element-515" data-mp="3a7egtg67pc0y">
          <div style={{
          width: '100%',
          height: 500
        }} data-fillout-id="5TKe1b8U6sus" data-fillout-embed-type="standard" data-fillout-inherit-parameters data-fillout-dynamic-resize data-id="element-516" data-mp="35935t246kvh5"></div>
        </div>
      </section>

      <SiteFooter currentPath="/practitioners" data-id="element-517" data-mp="3swbd1pl66elt" />
    </main>;
}